import { useEffect, useRef, useState } from "react";

// Scroll-reveal: attach `ref` to an element, spread `isIn` into its className
// (e.g. `reveal ${isIn ? "in" : ""}`). Reveals once, then stops observing.
// Honours prefers-reduced-motion by revealing immediately.
export function useReveal(threshold = 0.14) {
  const ref = useRef(null);
  const [isIn, setIsIn] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) {
      setIsIn(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsIn(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, isIn];
}